import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CreateContact from 'components/ContactModal/ContactModal';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => ({
  contactObj: ownProps.contact || _get(state, 'app.contactModal.contactObj'),
  isDelete: _get(state, 'app.contactModal.isDelete') || ownProps.isDelete,
  isCreate: _get(state, 'app.contactModal.isCreate') || ownProps.isCreate,
  isMeeting: _get(state, 'app.contactModal.isMeeting') || ownProps.isMeeting
});

export default injectIntl(connect(mapStateToProps)(CreateContact));
